import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CloneParticipantNote } from '../mutations/cloneParticipantNote.mutation';
import { CloneParticipantNoteMutation, CloneParticipantNoteMutationVariables } from '../types';

export const useCloneParticipantNoteMutation = (
  options?: MutationOptions<CloneParticipantNoteMutation, CloneParticipantNoteMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CloneParticipantNote), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
